import { render, staticRenderFns } from "./detailsRecitationAlertsView.vue?vue&type=template&id=b29acaa2&scoped=true&"
import script from "./detailsRecitationAlertsView.vue?vue&type=script&lang=js&"
export * from "./detailsRecitationAlertsView.vue?vue&type=script&lang=js&"
import style0 from "./detailsRecitationAlertsView.vue?vue&type=style&index=0&id=b29acaa2&prod&lang=scss&scoped=true&"
import style1 from "./detailsRecitationAlertsView.vue?vue&type=style&index=1&id=b29acaa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29acaa2",
  null
  
)

export default component.exports